import React from 'react';

import './strategy-fee-type.scss';

const options = [
	{
		name: 'marketplace',
		label: 'Marketplace (Standard)',
	},
	{
		name: 'direct_deal',
		label: 'Direct Deal',
	},
];

function StrategyFeeType({ feeTypeProp, strategyId, updateFeeType }) {
	const radioButtons = options.map((option, idx) => {
		return (
			<div className="radio-button" key={`${option.name}-fee-type`}>
				<input
					type="radio"
					value={option.name}
					name={`fee-type-radio-${strategyId}`}
					id={`${option.name}-radio-${strategyId}`}
					onClick={() => updateFeeType(option.name)}
					defaultChecked={feeTypeProp === option.name}
				/>
				<label className="radio-button-label" htmlFor={`${option.name}-radio-${strategyId}`}>
					{option.label}
				</label>
			</div>
		);
	});

	return (
		<div className="fee-type">
			<div className="label">Fee Type</div>
			<div>
				{radioButtons}
			</div>
		</div>
	);
}

export default StrategyFeeType;
